"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _generalStore = require("general-store");

var _I18n = _interopRequireDefault(require("I18n"));

var _loggers = require("customer-data-tracking/loggers");

var _EngagementRecord = _interopRequireDefault(require("customer-data-objects/engagement/EngagementRecord"));

var _EngagementMediator = require("crm_ui/components/profile/interactions/common/EngagementMediator");

var _CurrentOwnerContainer = _interopRequireDefault(require("crm_internal/containers/CurrentOwnerContainer"));

var _immutable = require("immutable");

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _tasksDateHelpers = require("crm_ui/tasks/helpers/tasksDateHelpers");

var _dateHelpers = require("crm_ui/utils/dateHelpers");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _GridUIActions = _interopRequireDefault(require("crm_ui/flux/grid/GridUIActions"));

var _UserSettingsActions = require("crm_data/settings/UserSettingsActions");

var _UserSettingsKeys = _interopRequireDefault(require("crm_data/settings/UserSettingsKeys"));

var _UserSettingsStore = _interopRequireDefault(require("crm_data/settings/UserSettingsStore"));

var _IsUngatedStore = _interopRequireDefault(require("crm_data/gates/IsUngatedStore"));

var _eventNames = require("customer-data-tracking/constants/eventNames");

var _engagementStatus = require("crm_ui/constants/engagementStatus");

var _LocalInteraction = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/local/LocalInteraction"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var FRIDAY = 5;
var SATURDAY = 6;

var _getBusinessDayLabel = function _getBusinessDayLabel(key, numberOfDays, format) {
  var now = _I18n.default.moment.userTz();

  var date = (0, _dateHelpers.addWeekdays)(now, numberOfDays);
  return _I18n.default.text(key, {
    day: date.format(format)
  });
};

var DAY_FORMAT = 'dddd';
var MONTH_DATE_FORMAT = 'MMMM D';
var FOLLOW_UP_DATE_CATEGORIES = [{
  value: 1,
  text: _getBusinessDayLabel('interactionWithFollowUpTask.categories.tomorrow', 1, DAY_FORMAT)
}, {
  value: 1,
  text: _getBusinessDayLabel('interactionWithFollowUpTask.categories.oneDay', 1, DAY_FORMAT),
  oneDay: true
}, {
  value: 2,
  text: _getBusinessDayLabel('interactionWithFollowUpTask.categories.twoDays', 2, DAY_FORMAT)
}, {
  value: 3,
  text: _getBusinessDayLabel('interactionWithFollowUpTask.categories.threeDays', 3, DAY_FORMAT)
}, {
  value: 5,
  text: _getBusinessDayLabel('interactionWithFollowUpTask.categories.oneWeek', 5, MONTH_DATE_FORMAT)
}, {
  value: 20,
  text: _getBusinessDayLabel('interactionWithFollowUpTask.categories.oneMonth', 20, MONTH_DATE_FORMAT)
}, {
  value: 60,
  text: _getBusinessDayLabel('interactionWithFollowUpTask.categories.threeMonths', 60, MONTH_DATE_FORMAT)
}, {
  value: 120,
  text: _getBusinessDayLabel('interactionWithFollowUpTask.categories.sixMonths', 120, MONTH_DATE_FORMAT)
}]; // TODO: remove after ungating Tasks:UsabilityImprovements:V2

var FOLLOW_UP_DATE_CATEGORIES_OLD = [{
  text: _I18n.default.text('interactionWithFollowUpTask.categories.one'),
  value: 1
}, {
  text: _I18n.default.text('interactionWithFollowUpTask.categories.many', {
    count: 2
  }),
  value: 2
}, {
  text: _I18n.default.text('interactionWithFollowUpTask.categories.many', {
    count: 3
  }),
  value: 3
}, {
  text: _I18n.default.text('interactionWithFollowUpTask.categories.many', {
    count: 4
  }),
  value: 4
}, {
  text: _I18n.default.text('interactionWithFollowUpTask.categories.many', {
    count: 5
  }),
  value: 5
}];

var _isNewTaskToday = function _isNewTaskToday(timestamp) {
  if ((0, _typeof2.default)(timestamp) === 'object') {
    return false;
  }

  return _I18n.default.moment(timestamp).isSame(_I18n.default.moment(), 'day');
};

var propTypes = {
  localInteraction: _propTypes.default.instanceOf(_LocalInteraction.default),
  isQueueTask: _propTypes.default.bool,
  subject: _SubjectType.default,
  dontRenderFollowUp: _propTypes.default.bool,
  onCreateFollowupTask: _propTypes.default.func,
  hasTasksUX2Gate: _propTypes.default.bool,
  engagementType: _propTypes.default.string,
  inTimeline: _propTypes.default.bool
};

function _default(Component, deps) {
  var initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var FollowUpTaskContainer =
  /*#__PURE__*/
  function (_PureComponent) {
    (0, _inherits2.default)(FollowUpTaskContainer, _PureComponent);

    function FollowUpTaskContainer() {
      var _this;

      (0, _classCallCheck2.default)(this, FollowUpTaskContainer);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FollowUpTaskContainer).call(this));
      (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
      _this.state = Object.assign(_this.handleGetInitialState(), initialState);
      return _this;
    }

    (0, _createClass2.default)(FollowUpTaskContainer, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var localInteraction = this.props.localInteraction;
        var includeFollowUpTask = this.state.includeFollowUpTask;

        if (localInteraction && localInteraction.data) {
          var currentIncludeFollowUpTask = localInteraction.data.get('includeFollowUpTask', includeFollowUpTask); // TODO: inline this one with selectedFollowUpCategory from this.state

          var currentSelectedFollowUpCategory = localInteraction.data.get('selectedFollowUpCategory', this.getFollowUpDateCategories().find(function (cat) {
            return cat.value === 3;
          }));

          if (_immutable.Map.isMap(currentSelectedFollowUpCategory)) {
            currentSelectedFollowUpCategory = currentSelectedFollowUpCategory.toJS();
          }

          var handleFollowUpTaskDataFormat = {
            target: {
              checked: currentIncludeFollowUpTask
            }
          };
          this.handleFollowUpTaskToggle(handleFollowUpTaskDataFormat);
          this.handleFollowUpCategoryChange(currentSelectedFollowUpCategory);
        } else {
          this.handleFollowUpCategoryChange(this.getFollowUpDateCategories()[2]);
        }
      } // TODO: inline all calls after ungating Tasks:UsabilityImprovements:V2

    }, {
      key: "getFollowUpDateCategories",
      value: function getFollowUpDateCategories() {
        var hasTasksUX2Gate = this.props.hasTasksUX2Gate;

        if (!hasTasksUX2Gate) {
          return FOLLOW_UP_DATE_CATEGORIES_OLD;
        }

        if (![FRIDAY, SATURDAY].includes(_I18n.default.moment.userTz().day())) {
          return FOLLOW_UP_DATE_CATEGORIES.filter(function (cat) {
            return !cat.oneDay;
          });
        }

        return FOLLOW_UP_DATE_CATEGORIES;
      }
    }, {
      key: "logCreateTask",
      value: function logCreateTask(source) {
        var _this$props = this.props,
            subject = _this$props.subject,
            isQueueTask = _this$props.isQueueTask;
        var objectType = (0, _ImmutableModel.getObjectType)(subject);
        var action = 'Auto created follow up task';

        if (isQueueTask) {
          _loggers.CrmLogger.logRecordInteraction(objectType, {
            action: 'Use task queues',
            subAction: 'Create follow up task in queue'
          });
        } else if (source === _eventNames.RECORD_INTERACTION) {
          _loggers.CrmLogger.logRecordInteraction(objectType, {
            action: action
          });

          var engagementType = this.props.engagementType;
          var activity = engagementType && engagementType.toLowerCase() || 'unknown';

          _loggers.CommunicatorLogger.log('communicatorUsage_createFollowUpTask', {
            activity: activity,
            channel: engagementType === _EngagementTypes.CALL ? 'outbound call' : activity,
            source: 'communicator'
          });
        } else if (source === _eventNames.INDEX_INTERACTION) {
          _loggers.CrmLogger.logIndexInteraction(_EngagementTypes.TASK, {
            action: action
          });
        }
      }
    }, {
      key: "handleGetInitialState",
      value: function handleGetInitialState() {
        return {
          includeFollowUpTask: false,
          selectedFollowUpCategory: FOLLOW_UP_DATE_CATEGORIES[2],
          dontAskAgainSetting: false
        };
      }
    }, {
      key: "handleGetFollowUpTimestamp",
      value: function handleGetFollowUpTimestamp() {
        var selectedFollowUpCategory = this.state.selectedFollowUpCategory; // category selected

        if (typeof selectedFollowUpCategory !== 'number') {
          return (0, _dateHelpers.addWeekdays)((0, _tasksDateHelpers.setToDefaultDueDate)(_I18n.default.moment.userTz()), selectedFollowUpCategory.value).valueOf();
        } // custom date selected


        if (!_isNewTaskToday(this.state.selectedFollowUpCategory)) {
          return (0, _tasksDateHelpers.setToDefaultDueDate)(_I18n.default.moment.userTz(selectedFollowUpCategory)).valueOf();
        }

        return selectedFollowUpCategory;
      }
    }, {
      key: "makeEngagement",
      value: function makeEngagement(attributes) {
        var timestamp = this.handleGetFollowUpTimestamp();

        var ownerId = _CurrentOwnerContainer.default.get();

        var defaultAttributes = {
          engagement: {
            timestamp: timestamp,
            type: _EngagementTypes.TASK,
            ownerId: ownerId
          }
        };

        if (_isNewTaskToday(this.state.selectedFollowUpCategory)) {
          attributes.metadata.reminders = [];
          attributes.metadata.sendDefaultReminder = false;
        } else {
          var reminders = (0, _tasksDateHelpers.setToDefaultReminderDate)(_I18n.default.moment(timestamp)).valueOf();
          attributes.metadata.reminders = [reminders];
        }

        attributes.metadata.status = _engagementStatus.NOT_STARTED;
        var options = (0, _immutable.fromJS)(Object.assign(defaultAttributes, attributes));
        return (0, _EngagementRecord.default)(options);
      }
    }, {
      key: "handleFollowUpCategoryChange",
      value: function handleFollowUpCategoryChange(category) {
        if (category === 'custom') {
          category = (0, _tasksDateHelpers.setToDefaultDueDate)().valueOf();
        }

        if (category === null) {
          category = this.getFollowUpDateCategories().find(function (cat) {
            return cat.value === 3;
          });
        }

        this.setState({
          selectedFollowUpCategory: category
        });
      }
    }, {
      key: "handleFollowUpTaskToggle",
      value: function handleFollowUpTaskToggle(_ref) {
        var checked = _ref.target.checked;
        var objectType = (0, _ImmutableModel.getObjectType)(this.props.subject);

        if (checked) {
          _loggers.CrmLogger.logRecordInteraction(objectType, {
            action: 'communicator interaction',
            subAction: 'create follow-up task'
          });

          var engagementType = this.props.engagementType;
          var activity = engagementType && engagementType.toLowerCase() || 'unknown';

          _loggers.CommunicatorLogger.log('communicatorInteraction', {
            action: 'Click to create followup task',
            activity: activity,
            channel: engagementType === _EngagementTypes.CALL ? 'outbound call' : activity,
            source: this.props.inTimeline ? 'timeline' : 'communicator'
          });
        }

        this.setState({
          includeFollowUpTask: checked
        });
      }
    }, {
      key: "handleCreateFollowUpTask",
      value: function handleCreateFollowUpTask(additionalOptions, source) {
        var _this2 = this;

        if (!this.state.includeFollowUpTask) {
          return;
        }

        var followUpEngagement = this.makeEngagement(additionalOptions);
        (0, _EngagementMediator.createEngagement)(followUpEngagement, _EngagementTypes.TASK).then(function (task) {
          var taskId = task.getIn(['engagement', 'id']);

          if (taskId && _this2.props.onCreateFollowupTask) {
            _this2.props.onCreateFollowupTask(taskId);
          }

          _GridUIActions.default.temporarilyIncludeId(taskId);
        });
        this.logCreateTask(source);
      }
    }, {
      key: "handleToggleDontAskSetting",
      value: function handleToggleDontAskSetting(_ref2) {
        var checked = _ref2.target.checked;
        this.setState({
          dontAskAgainSetting: checked
        });
      }
    }, {
      key: "handleOnComplete",
      value: function handleOnComplete() {
        this.setState(this.handleGetInitialState());

        if (!this.state.dontAskAgainSetting) {
          return;
        }

        (0, _UserSettingsActions.saveUserSetting)(_UserSettingsKeys.default.DONT_SHOW_FOLLOW_UP_TASK, true);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
            includeFollowUpTask = _this$state.includeFollowUpTask,
            selectedFollowUpCategory = _this$state.selectedFollowUpCategory,
            dontAskAgainSetting = _this$state.dontAskAgainSetting;
        var dontRenderFollowUp = this.props.dontRenderFollowUp;
        /*
          dontAskAgainSetting: state of the checkbox
          dontRenderFollowUp: actual user setting
        */

        return _react.default.createElement(Component, (0, _extends2.default)({}, this.props, {
          handleCreateFollowUpTask: this.handleCreateFollowUpTask,
          handleFollowUpCategoryChange: this.handleFollowUpCategoryChange,
          handleFollowUpTaskToggle: this.handleFollowUpTaskToggle,
          handleToggleDontAskSetting: this.handleToggleDontAskSetting,
          handleGetFollowUpTimestamp: this.handleGetFollowUpTimestamp,
          followUpCategories: this.getFollowUpDateCategories(),
          includeFollowUpTask: includeFollowUpTask,
          selectedFollowUpCategory: selectedFollowUpCategory,
          dontAskAgainSetting: dontAskAgainSetting,
          dontRenderFollowUp: dontRenderFollowUp,
          onCompleteTaskWithFollowUp: this.handleOnComplete
        }));
      }
    }]);
    return FollowUpTaskContainer;
  }(_PureComponent2.default);

  var defaultDeps = {
    // TODO: remove after ungating Tasks:UsabilityImprovements:V2
    hasTasksUX2Gate: {
      stores: [_IsUngatedStore.default],
      deref: function deref() {
        return _IsUngatedStore.default.get('Tasks:UsabilityImprovements:V2');
      }
    },
    dontRenderFollowUp: {
      stores: [_UserSettingsStore.default],
      deref: function deref() {
        return _UserSettingsStore.default.get(_UserSettingsKeys.default.DONT_SHOW_FOLLOW_UP_TASK);
      }
    }
  };
  FollowUpTaskContainer.propTypes = propTypes;
  return (0, _generalStore.connect)(Object.assign(defaultDeps, deps))(FollowUpTaskContainer);
}

module.exports = exports.default;